export default __webpack_public_path__ + "static/media/dot-failed.0715012c.svg";